import { render, staticRenderFns } from "./PostRemarks.vue?vue&type=template&id=80d85c3e"
import script from "./PostRemarks.vue?vue&type=script&lang=js"
export * from "./PostRemarks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports